let navigation_admin = [
  {
    text: 'Törzsadatok',
    key: 'masterData',
    icon: 'folder',
    type: 'menu',
    items: [
      {
        text: 'Felhasználók',
        key: 'users',
        path: '/users',
        type: 'menu',
      },
      {
        text: 'Kategóriák',
        key: 'categories',
        path: '/categories',
        type: 'menu',
      },
      {
        text: 'Videók beállítása',
        key: 'videoAssign',
        path: '/videoAssign',
        type: 'menu',
      },
      {
        text: 'Előfizetések',
        key: 'subscriptions',
        path: '/subscriptions',
        type: 'menu',
      },

      {
        text: 'Egyéb tartalmak',
        key: 'freeContentEditor',
        path: '/freeVideos',
        type: 'menu',
      },
    ],
  },
  {
    text: 'Ellenőrzések',
    key: 'processChecks',
    icon: 'hierarchy',
    type: 'menu',
    items: [
      {
        text: 'Megrendelések',
        key: 'allOrders',
        path: '/allOrders',
        type: 'menu',
      },
    ],
  },
  {
    text: 'Kimutatások',
    key: 'reports',
    icon: 'doc',
    type: 'menu',
    items: [
      {
        text: 'Bevételek',
        key: 'income_stat',
        path: '/IncomeStat',
        type: 'menu',
      },
      {
        text: 'Nézettség',
        key: 'video_stat',
        path: '/videoStat',
        type: 'menu',
      },
    ],
  },
];

let navigation_user = [
  {
    text: 'Kezdőlap',
    key: 'home',
    path: '/home',
    icon: 'home',
    type: 'menu',
  },
  {
    text: 'Profilom',
    key: 'profile',
    path: '/profile',
    icon: 'card',
    type: 'menu',
  },
];

export { navigation_admin, navigation_user };
